<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12">
                    <ValidationProvider name="semester_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox :validate-error="errors[0]"
                                                 v-model="formData.semester_id" :setActive="true"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="student_program_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('name_surname')">
                            <students-auto-complete
                                :value="`${formData.name} ${formData.surname}`"
                                @user-input="handleSelection"
                                :in-all-students="true"
                                :validate-error="errors[0]"></students-auto-complete>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                        <ValidationProvider name="course_id" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('course')">
                                <course-auto-complete v-model="formData.course_id"
                                                      :validate-error="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="hours" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('hours')">
                            <b-form-input type="number"
                                          v-model="formData.hours"
                                          :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="createForm" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save') }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"

    //Components
    import StudentsAutoComplete from "@/components/interactive-fields/StudentsAutoComplete.vue";
    import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox"

    //Service
    import OtherPaymentMakeupLessonService from "@/services/OtherPaymentMakeupLessonService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

            StudentsAutoComplete,
            SemestersSelectbox,
        },
        data() {
            return {
                formLoading: false,
                formData: {}
            }
        },
        methods: {
            handleSelection(user) {
                this.formData.student_program_id = user?.student_program_id;
            },
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    OtherPaymentMakeupLessonService.store(this.formData)
                               .then((response) => {
                                   this.$toast.success(this.$t("api." + response.data.message));
                                   this.$emit("createFormSuccess")
                               })
                               .catch((error) => {
                                   this.showErrors(error, this.$refs.formModalValidate)
                               }).finally(() => {
                        this.formLoading = false;
                    });
                }
            },
        }
    }
</script>
